import { render, staticRenderFns } from "./UpdateRoleUserDialog.vue?vue&type=template&id=66b45a63&"
import script from "./UpdateRoleUserDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateRoleUserDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports